import { Navigate, useLocation } from "react-router-dom";
// HOOK
import useAuth from "app/hooks/useAuth";

export default function AuthGuard({ children }) {
  const { accessToken} = useAuth();
  const { pathname } = useLocation();

  if (accessToken) return <>{children}</>;

  return <Navigate replace to="/session/signin" state={{ from: pathname }} />;
}
